import React, { useEffect, useState } from "react";
import "./message.css";
import CancelIcon from "@mui/icons-material/Cancel";
import instance from "../../ApiInstance/Inetrceptor";
import {
  Drawer,
  Grid,
  Checkbox,
  Button,
  InputLabel,
  TextField,
  Typography,
  Alert,
  InputAdornment,
} from "@mui/material";
import { useTheme } from "@mui/material/styles";
import useMediaQuery from "@mui/material/useMediaQuery";
import Autocomplete from "@mui/material/Autocomplete";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";

const RoutingStatusDrawer = ({
  getRoutingStatus,
  setIsDrawerOpen,
  isDrawerOpen,
  drawerCaller,
  setBackDrop,
}) => {
  const type = drawerCaller?.name ?? "Add";
  const filledInfo = drawerCaller?.data ?? {};
  const theme = useTheme();
  const isXs = useMediaQuery(theme.breakpoints.down("xs"));
  const isSm = useMediaQuery(theme.breakpoints.between("sm", "xs"));
  const isMd = useMediaQuery(theme.breakpoints.between("md", "sm"));
  const isLg = useMediaQuery(theme.breakpoints.between("lg", "md"));
  const isXl = useMediaQuery(theme.breakpoints.up("xl"));
  let drawerWidth = "600px";
  if (isXs || window.innerWidth < 1000) {
    drawerWidth = "250px";
  } else if (isSm) {
    drawerWidth = "300px";
  } else if (isMd) {
    drawerWidth = "400px";
  } else if (isLg) {
    drawerWidth = "600px";
  } else if (isXl) {
    drawerWidth = "600px";
  }
  const [error, setError] = useState(null);
  const [success, setSuccess] = useState(null);
  const [information, setInformation] = useState({});
  const [alterTypeInformation, setAlterTypeInformaiton] = useState([]);
  const handleDrawerClose = (event) => {
    // if (event.target.id === "back-button") {
      setIsDrawerOpen(false);
    // }
  };
  const createNewRoutingStatus = () => {
    const message_routing_status_code =
      information?.message_routing_status_code?.trim();
    const alert_type_id = information?.alert_type_id;
    if (message_routing_status_code.length == 0 || alert_type_id == 0) {
      setError("Please fill all the mandatory fields");
      setTimeout(() => {
        setError(null);
      }, 4000);
      return;
    }
    const body = {
      message_routing_status_id: information?.message_routing_status_id ?? 0,
      message_routing_status_code:
        information?.message_routing_status_code ?? 0,
      message_routing_status_desc:
        information?.message_routing_status_desc ?? "",
      is_active: information?.is_active ?? 0,
      alert_type_id: information?.alert_type_id ?? 0,
    };
    setBackDrop(true);
    instance
      .post("api/v1/Master/MessageRoutingStatus/Post", body)
      .then((res) => {
        if (res?.data?.Success) {
          setError(null);
          setSuccess(res?.data?.ResultMessage);
          getRoutingStatus();
          setTimeout(() => {
            setSuccess(null);
          }, 5000);
        } else {
          setError(res?.data?.ResultMessage);
          setTimeout(() => {
            setError(null);
          }, 5000);
        }
        if (type === "Add") {
          setInformation({
            message_routing_status_code: "",
            alert_type_id: "",
          });
        }
      })
      .catch((err) => {
        console.log(err);
      })
      .finally(() => {
        setBackDrop(false);
      });
  };

  const onChanageHandler = (event) => {
    const { id, value, type } = event?.target;
    if (type == "checkbox") {
      setInformation((prev) => {
        return {
          ...prev,
          [id]: event?.target?.checked == true ? 1 : 0,
        };
      });
    } else {
      setInformation((prev) => {
        return {
          ...prev,
          [id]: value,
        };
      });
    }
  };

  const getAlterType = async () => {
    await instance
      .post("api/v1/Master/AlertType/Get", {})
      .then((res) => {
        if (res?.data?.Success) {
          setAlterTypeInformaiton(res?.data?.Value ?? {});
        } else {
          setAlterTypeInformaiton({});
        }
      })
      .catch((err) => {
        console.log(err);
      });
  };
  useEffect(() => {
    getAlterType();
    setInformation({
      message_routing_status_id: filledInfo?.message_routing_status_id ?? 0,
      message_routing_status_code:
        filledInfo?.message_routing_status_code ?? "",
      message_routing_status_desc:
        filledInfo?.message_routing_status_desc ?? "",
      is_active: filledInfo?.is_active ?? 0,
      alert_type_id: filledInfo?.alert_type_id ?? 0,
    });
  }, [drawerCaller]);
  return (
    <Drawer
      anchor="right"
      open={isDrawerOpen}
      PaperProps={{
        sx: {
          width: drawerWidth,
        },
      }}
    >
      <div style={{ padding: "20px" }}>
        <Grid container spacing={2}>
          <Grid item xs={12}>
            <Button
              id="back-button"
              variant="contained"
              color="transparent"
              className="button_backmsg"
              onClick={handleDrawerClose}
              startIcon={<ArrowBackIcon  onClick={handleDrawerClose}/>}
            >
              Back
            </Button>
          </Grid>
          <Grid item xs={12}>
            <Typography
              variant="h5"
              className="font-colormsg mb-0"
              style={{ fontWeight: "600" }}
            >
              {type == "Add" ? "Add" : "Edit"} Routing Status{" "}
            </Typography>
          </Grid>
          <Grid item xs={12}>
            <Typography
              variant="h7"
              className="font-colormsg mb-1"
              style={{ fontWeight: "600" }}
            >
              Routing Status Information{" "}
            </Typography>
          </Grid>
          <Grid item xs={12}>
            {error && (
              <Alert
                variant="outlined"
                severity="error"
                icon={
                  <CancelIcon
                    onClick={() => setError(null)}
                    style={{ cursor: "pointer" }}
                  />
                }
                className="errorAlertMaintain mt-4"
              >
                {error}
              </Alert>
            )}
            {success && (
              <Alert
                variant="outlined"
                severity="success"
                className="sucessAlertMaintain mt-4"
              >
                {success}
              </Alert>
            )}
          </Grid>
          <Grid item xs={12}>
            <InputLabel htmlFor="message_routing_status_code">
              Routing Status Code<span style={{ color: "red" }}>*</span>
            </InputLabel>
            <TextField
              id="message_routing_status_code"
              size="small"
              value={information?.message_routing_status_code}
              onChange={onChanageHandler}
              variant="outlined"
              fullWidth
            />
          </Grid>
          <Grid item xs={12}>
            <InputLabel htmlFor="message_routing_status_desc">
              Routing Status Description
            </InputLabel>
            <TextField
              id="message_routing_status_desc"
              size="small"
              multiline
              rows={4}
              value={information?.message_routing_status_desc}
              onChange={onChanageHandler}
              variant="outlined"
              fullWidth
            />
          </Grid>
          <Grid item xs={12}>
            <InputLabel htmlFor="alert_type_id">
              Alert Type<span style={{ color: "red" }}>*</span>
            </InputLabel>
            <Autocomplete
              size="small"
              id={"alert_type_id"}
              value={
                alterTypeInformation.find(
                  (option) => option.alert_type_id === information.alert_type_id
                ) || null
              }
              onChange={(event, newValue) => {
                setInformation((prev) => {
                  return {
                    ...prev,
                    alert_type_id: newValue?.alert_type_id,
                  };
                });
              }}
              options={alterTypeInformation}
              getOptionLabel={(option) => option.alert_type_desc}
              disableClearable
              renderInput={(params) => (
                <TextField
                  {...params}
                  size="small"
                  variant="outlined"
                  // InputProps={{
                  //   ...params.InputProps,
                  //   endAdornment: (
                  //     <InputAdornment
                  //       position="end"
                  //       style={{ position: "absolute", right: 20 }}
                  //     >
                  //       <img
                  //         src="assets/Images/searchicon.svg"
                  //         alt="Search Icon"
                  //       />
                  //     </InputAdornment>
                  //   ),
                  // }}
                />
              )}
            />
          </Grid>
          <Grid item xs={12}>
            <Checkbox
              color="secondary"
              id="is_active"
              checked={information?.is_active == 1 ? true : false}
              onChange={onChanageHandler}
            />
            <Typography variant="h7" className="font-colormsg mb-1">
              Is Active?
            </Typography>
          </Grid>
          <Grid item xs={12} sx={{ textAlign: "right" }}>
            <Button
              id="back-button"
              variant="contained"
              color="secondary"
              onClick={() => {
                createNewRoutingStatus();
              }}
            >
              {type == "Add" ? "Create" : "Save Changes"}
            </Button>
          </Grid>
        </Grid>
      </div>
    </Drawer>
  );
};

export default RoutingStatusDrawer;
